/**
 * Newsletter: submit (customer form via fetch, birthday saved as tag
 * "cumple-MM-DD"), show + copy the welcome code, and the exit pop-up:
 * - desktop: mouse leaves through the top of the window
 * - mobile: a fast upward scroll after reading a while (no mouse on phones)
 * Shown at most once every 7 days, never after signing up, never on /cart,
 * never before 15 s on the site or while another dialog is open.
 */
(() => {
  if (window.BrisatoNewsletter) return;
  window.BrisatoNewsletter = true;

  const DONE = 'brisato_nl_done';
  const SEEN = 'brisato_nl_seen';
  const store = {
    get: (k) => {
      try {
        return window.localStorage.getItem(k);
      } catch (_) {
        return null;
      }
    },
    set: (k, v) => {
      try {
        window.localStorage.setItem(k, v);
      } catch (_) {
        /* private mode: the pop-up may show again, that's fine */
      }
    },
  };

  /* ---------- Submit ----------
   * Shopify's bot protection rejects customer forms sent in the background
   * (403), so the form submits normally. Before leaving we remember which form
   * it was; when Shopify brings the visitor back with ?customer_posted=true we
   * show the welcome code there.
   */
  const PENDING = 'brisato_form_pending';
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-newsletter-form]');
    if (!form) return;
    const box = form.closest('[data-newsletter]');
    const bday = form.querySelector('[data-newsletter-birthday]');
    const tags = form.querySelector('[data-newsletter-tags]');
    const base = 'newsletter, bienvenida-10';
    tags.value = bday && bday.value ? `${base}, cumple-${bday.value.slice(5)}` : base;
    if (bday) bday.disabled = true; // not a Shopify field; travels as a tag instead
    form.querySelector('button[type="submit"]').setAttribute('aria-busy', 'true');
    try {
      window.sessionStorage.setItem(PENDING, box.closest('dialog') ? 'newsletter-popup' : 'newsletter-footer');
    } catch (_) {
      /* the code still shows in the welcome email */
    }
    if (window.Shopify && window.Shopify.analytics) {
      window.Shopify.analytics.publish('brisato_newsletter_signup', { source: box.closest('dialog') ? 'popup' : 'footer' });
    }
  });

  const showDone = (box) => {
    if (!box) return;
    box.querySelector('[data-newsletter-form]').hidden = true;
    box.querySelector('[data-newsletter-done]').hidden = false;
  };

  let pending = null;
  try {
    pending = window.sessionStorage.getItem(PENDING);
  } catch (_) {
    pending = null;
  }
  const posted = /[?&]customer_posted=true/.test(window.location.search);
  if (posted && pending && pending.startsWith('newsletter')) {
    try {
      window.sessionStorage.removeItem(PENDING);
    } catch (_) {
      /* ignore */
    }
    store.set(DONE, '1');
    const popup = document.querySelector('[data-newsletter-dialog]');
    if (pending === 'newsletter-popup' && popup) {
      showDone(popup.querySelector('[data-newsletter]'));
      popup.showModal();
    } else {
      const footerBox = document.querySelector('.site-footer [data-newsletter]');
      showDone(footerBox);
      if (footerBox) footerBox.scrollIntoView({ block: 'center' });
    }
  }

  /* ---------- Copy code ---------- */
  document.addEventListener('click', async (event) => {
    const copy = event.target.closest('[data-newsletter-copy]');
    if (copy) {
      try {
        await navigator.clipboard.writeText(copy.dataset.code);
        copy.querySelector('[data-copy-label]').textContent = copy.dataset.copied || '✓';
      } catch (_) {
        /* the code is visible anyway */
      }
    }
    const close = event.target.closest('[data-newsletter-close]');
    if (close) close.closest('dialog').close();
  });

  /* ---------- Exit pop-up ---------- */
  const dialog = document.querySelector('[data-newsletter-dialog]');
  if (!dialog) return;
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  const start = Date.now();
  const weekMs = 7 * 24 * 60 * 60 * 1000;
  const eligible = () => {
    if (store.get(DONE)) return false;
    const seen = Number(store.get(SEEN) || 0);
    if (seen && Date.now() - seen < weekMs) return false;
    if (Date.now() - start < 15000) return false;
    if (/\/cart/.test(window.location.pathname)) return false;
    if (document.querySelector('dialog[open]')) return false;
    return true;
  };
  const show = () => {
    if (!eligible()) return;
    store.set(SEEN, String(Date.now()));
    dialog.showModal();
    if (window.Shopify && window.Shopify.analytics) window.Shopify.analytics.publish('brisato_newsletter_popup_shown', {});
  };

  // Desktop: pointer leaves through the top edge
  document.addEventListener('mouseout', (event) => {
    if (!event.relatedTarget && event.clientY <= 0) show();
  });

  // Mobile: fast upward scroll after scrolling down a fair way
  let lastY = window.scrollY;
  let lastT = performance.now();
  let maxY = 0;
  window.addEventListener(
    'scroll',
    () => {
      const y = window.scrollY;
      const t = performance.now();
      maxY = Math.max(maxY, y);
      const speed = (lastY - y) / Math.max(1, t - lastT); // px per ms, positive = up
      if (speed > 2.2 && maxY > 900 && window.matchMedia('(hover: none)').matches) show();
      lastY = y;
      lastT = t;
    },
    { passive: true }
  );
})();
